import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import * as Const from '../../../../common/const';
import { isNullOrUndefined } from "util";
import './generalFilters.css';

class GeneralFiltersComponent extends React.Component {
    
    constructor(props){

        //generalFilters, toggleGeneralFilter
        super(props);

        this.state = {

        }

        
        this.clickSingleOption = this.clickSingleOption.bind(this);
        this.renderSingleOption = this.renderSingleOption.bind(this);
    }

    clickSingleOption(option){
        // console.log(option)
        this.props.toggleGeneralFilter(option);
    }

    renderSingleOption(option){
        
        return (
            <Paper className={'singleGeneralFilter singleGeneralFilter-selected-'+
            String(option.selected) +' '}
            onClick = {() =>{this.clickSingleOption(option.filter)}}>
                <span className={'singleGeneralFilterText'} >{option.text}</span>
            </Paper>
        )
    }

    render(){

        // console.log(this.props.generalFilters);
        let renderFilterItems = null;
        if(!isNullOrUndefined(this.props.generalFilters)){
            renderFilterItems = Object.keys(this.props.generalFilters).map((filter) => {
                let text = filter;
                if(filter in Const.filterData){
                    text = Const.filterData[filter].name;
                }
                let selected = this.props.generalFilters[filter];
                return (
                    <Grid item lg={3} md={3} sm={4} xs={12}>
                        {this.renderSingleOption({'text':text, 'filter': filter, 'selected':selected})}
                    </Grid>
                )
            })
        }


        return (
            <div className="generalFiltersContainer">
                <Grid container spacing={2}>
                    {renderFilterItems}
                </Grid>
            </div>
        )
    }
}
export default GeneralFiltersComponent;